// src/constants/services.js

export const SERVICES = {
  AUTH: {
    name: "Authentication Service",
    baseUrl: "https://pro.mokshiq.in",
    version: "v1",
    resource: "Auth",
    endpoints: {
      sendOtp: {
        url: "/login_request",
        method: "POST",
        description: "Send OTP for login",
        bodyType: "formData",
        bodySchema: {
          phone: "string",
          password: "string",
        },
        responseSchema: {
          status: "boolean",
          data: "object",
          message: "string",
        },
        rateLimit: { requests: 5, window: "15m" },
        cache: { enabled: false },
        invalidates: ["Auth"],
      },

      verifyOtp: {
        url: "/login_with_otp",
        method: "POST",
        description: "Verify OTP and complete login",
        bodyType: "formData",
        bodySchema: {
          phone: "string",
          otp: "string",
          user_token: "string",
        },
        responseSchema: {
          status: "boolean",
          data: "object",
          token: "string",
          refreshToken: "string",
        },
        cache: { enabled: false },
        invalidates: ["Auth", "User"],
      },

      register: {
        url: "/register_api",
        method: "POST",
        description: "Register new user",
        bodyType: "formData",
        bodySchema: {
          name: "string",
          email: "string",
          phone: "string",
          password: "string",
        },
        responseSchema: {
          status: "boolean",
          data: "object",
          message: "string",
        },
        cache: { enabled: false },
        invalidates: ["Auth"],
      },

      getCurrentUser: {
        url: "/me",
        method: "GET",
        description: "Get current user profile",
        requiresAuth: true,
        cache: { enabled: true, ttl: 300, tags: ["Auth"] },
        responseSchema: {
          id: "string",
          name: "string",
          email: "string",
          phone: "string",
          role: "string",
          permissions: "array",
        },
      },

      logout: {
        url: "/logout",
        method: "POST",
        description: "User logout",
        bodyType: "formData",
        requiresAuth: true,
        cache: { enabled: false },
        invalidates: ["Auth", "User"],
      },

      refreshToken: {
        url: "/refresh",
        method: "POST",
        description: "Refresh authentication token",
        bodyType: "formData",
        bodySchema: { refreshToken: "string" },
        cache: { enabled: false },
        responseSchema: { token: "string", refreshToken: "string" },
      },
    },
  },

  // Add other services here following the same pattern
  USERS: {
    name: "User Management Service",
    baseUrl: "https://pro.mokshiq.in/api/users",
    version: "v1",
    resource: "User",
    endpoints: {
      list: {
        url: "/",
        method: "GET",
        description: "Get list of users",
        requiresAuth: true,
        cache: { enabled: true, ttl: 300, tags: ["User"] },
        queryParams: ["page", "limit", "search", "role", "status"],
        responseSchema: {
          data: "array",
          pagination: "object",
        },
        permissions: ["users:read"],
      },
    },
  },
};
